// ----------------------------------------------------------------------

// The actual site copy lives in src/content/de.ts — this i18next resource
// only exists so 'de' is a registered language for react-i18next.

const de = {
  demo: {
    title: `Deutsch`,
  },
};

export default de;
